// @flow
import type { State } from 'types/redux';

export function getAddress(state: State) {
  if (state.user.personInfo) {
    return state.user.personInfo.contactInfo.address;
  }
}

export function getAddressCountryCode(state: State) {
  if (state.user.personInfo) {
    return state.user.personInfo.contactInfo.address.country;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/appointment/contactInfo/address/selectors.js